import CaptchaA from "@/components/CaptchaA.vue";

export default {
    components: {CaptchaA},
    data() {
        return {
            aiLoginToken:'',
            selectedIcon: '我的',
            showBackArr: [
                'BidDetail',
                'detail',
                'profile',
                'aboutUs',
                'orderBill',
                'mark',
                'myProduct',
                'myOrder'
            ],
            isTermChecked: false,
            registerTextChange: false,
            isLoginBtnActive: false,
            isSendVerificationBtnActive: false, // 发送验证码按钮是否可用
            isSendCountDown: false, // 是否正在验证码倒计时,
            isSendBtnLoading: false, // 发送验证码按钮是否请求中
            isLoginBtnLoading: false, // 登录按钮是否请求中
            sendCountDownNumber: 180, // 验证码倒计时数字
            phoneLoginObj: {   // 验证码登录
                phone: '',
                verificationCode: ''
            },
            passLoginObj: {   // 密码登录
                account: '',
                password: ''
            },
            rules: {
                phone: this.$verify.ruleEmptyStr(this.$t('请填写手机号')),
                verificationCode: this.$verify.ruleEmptyStr(this.$t('请填写验证码')),
                account: this.$verify.ruleEmptyStr(this.$t('请填写手机号或账号')),
                password: this.$verify.ruleEmptyStr(this.$t('请填写密码')),
            },
            isMobileLoginDialogShow: false,
            loginType: '密码登录',
            resizeTimeout: null,
            info: {},
            rememberMe: true,
        };
    },
    methods: {
        getAllLoginToken(){

        },
        // 跳转页面
        routePcTo(name) {
            console.log("pc-name:",name)
            if (name === '商城') {
                this.$router.push('/index/searching')
            }else if (name === '竞拍') {
                // this.$router.push('/index/bid')
                window.location.href="http://jingpai.front1.xinhe.asia:9091/"

            }else if (name === '监管仓') {
                this.$hint.message.info(this.$t('该模块正在开发中......'));
                // this.$router.push('/index/monitor')
            }else if (name === '物流') {
                window.location.href="http://ship.xinhe.asia/front-h5/index.html"
                // this.$router.push('/index/transport')
            }else if (name === 'AI数据') {
                this.$hint.message.info(this.$t('该模块正在开发中......'));
                //暂时直接跳转链接。不跳转路由
                // window.location.href="http://board.xinhe.asia/data-board/index.html"
                // this.$router.push('/index/data')
            }else {
                this.$router.push('/index/notFound')
            }

            this.selectedIcon = name;
        },

        // 跳转页面
        routeTo(name) {
            console.log("mobile-name:",name)
            if (name === '我的') {
                this.$router.push('/index')
            }else if (name === '商城') {
                this.$router.push('/index/searching')
            }else if (name === '竞拍') {
                this.$router.push('/index/bid')
            }else if (name === '监管仓') {
                this.$router.push('/index/monitor')
            }else if (name === '物流') {
                this.$router.push('/index/transport')
            }else if (name === 'AI数据') {

                this.$router.push('/index/data')
            }else {
                this.$router.push('/index/notFound')
            }

            this.selectedIcon = name;
        },
        canBack() {
            let path = this.$route.path;
            for (let item of this.showBackArr) {
                if (path.includes(item)) {
                    return true;
                }
            }
            return false;
        },
        // 手机号输入时触发
        onPhoneInput() {
            this.isSendVerificationBtnActive = this.$verify.checkPhone(this.phoneLoginObj.phone);
            // 也需要判断登录按钮是否激活，防止输完验证码又修改手机号的情况
            this.onInput(); // 判断不为空
            this.isLoginBtnActive = this.isSendVerificationBtnActive && this.isLoginBtnActive; // 手机号无效也不激活登录按钮
        },
        // 验证码输入框 和 密码输入框 正在输入, 判断 登录按钮置灰或激活
        onInput() {
            this.isLoginBtnActive = this.phoneLoginObj.phone.length > 0 && this.phoneLoginObj.verificationCode.length > 0;
        },
        // 登陆方法
        doLogin(type) {
            console.log(this.$t('请填写手机号'))
            if (!this.isTermChecked) {
                this.$myAnime.shakeElement('.termsOfService',1);
                this.$hint.message.info(this.$t('请先阅读并同意条款'));
                return;
            }
            this.isLoginBtnLoading = true;
            if (type === 'phoneLoginObj') {
                this.$http.doLoginWithPhone(this.phoneLoginObj.phone, this.phoneLoginObj.verificationCode).then(res => {
                    this.isLoginBtnLoading = false;
                    if (res.code === 200) {
                        this.$store.commit('setToken', res.data.e1);
                        this.$store.commit('setCurrentUser', res.data.e2);
                        this.loginTypeChanged(); // 清空登录相关数据
                        this.isMobileLoginDialogShow = false; // 关闭手机登录弹窗
                        this.isLoginBtnLoading = false;

                        location.reload();
                    }else {
                        this.$hint.message.info(this.$t('验证码错误'));
                    }
                })
            }else {
                this.$http.doLogin(this.passLoginObj.account, this.passLoginObj.password).then(res => {
                    this.isLoginBtnLoading = false;
                    if (res.code === 200) {
                        this.$store.commit('setToken', res.data.e1);
                        this.$store.commit('setCurrentUser', res.data.e2);
                        this.loginTypeChanged(); // 清空登录相关数据
                        this.isMobileLoginDialogShow = false; // 关闭手机登录弹窗
                        this.isLoginBtnLoading = false;
                        // 记录 cookie
                        if (this.rememberMe) {
                            this.$cookie.set('account',this.passLoginObj.account,30);
                            this.$cookie.set('password',this.passLoginObj.password,30);
                        }

                        location.reload();
                    }else {
                        this.$hint.message.info(this.$t('错误的账号或密码'));
                    }
                })
            }
        },
        // 登录类型切换 或 登录dialog关闭时触发
        loginTypeChanged() {
            this.$refs['phoneLoginObj'].clearValidate();
            this.$util.trimFieldsToEmpty(this.phoneLoginObj);
            this.isSendVerificationBtnActive = false; // 发送验证码按钮关闭
            this.isLoginBtnActive = false; // 登录按钮关闭
        },
        // 发送短信验证码
        sendPhoneVerificationCode() {
            this.isSendBtnLoading = true;
            this.$http.sendPhoneVerificationCode(this.phoneLoginObj.phone).then(res => {
                this.isSendBtnLoading = false;
                if (res.code === 200) { // 发送成功
                    this.isSendCountDown = true;
                    this.sendCountDownInterval = setInterval(() => {
                        if (this.sendCountDownNumber > 0) {
                            this.sendCountDownNumber--;
                        } else {
                            this.isSendCountDown = false;
                            this.sendCountDownNumber = 180;
                            clearInterval(this.sendCountDownInterval);
                        }
                    }, 1000)
                } else if (res.code === 400) {  // 频繁
                    this.isSendCountDown = true;
                    this.sendCountDownNumber = res.data;
                    this.sendCountDownInterval = setInterval(() => {
                        if (this.sendCountDownNumber > 0) {
                            this.sendCountDownNumber--;
                        } else {
                            this.isSendCountDown = false;
                            this.sendCountDownNumber = 180;
                            clearInterval(this.sendCountDownInterval);
                        }
                    }, 1000)
                }
            })
        },
        getUserInfo() {
            if (this.$store.state.currentUser !== null) {
                this.$http.getUserInfo().then(res => {
                    this.info = res.data;
                })
            }
        },
        // 退出登录
        logOut() {
            // 清空 Vuex 中的 token 和 currentUser
            this.$store.commit("setToken", null);
            this.$store.commit("setCurrentUser", null);

            // 删除指定 cookies
            this.$cookie.delete('autoLoginCurrentUser');
            this.$cookie.delete('autoLoginToken');

            // 清空 sessionStorage 和 localStorage
            sessionStorage.setItem('vuex',null)
            this.$cookie.delete('account')
            this.$cookie.delete('password')

            // 刷新页面
            location.reload();
        },
        developing(){
            this.$hint.message.info(this.$t('该模块正在开发中！'));
        },
        routeToNeedLogin(path) {
            if (this.$store.state.currentUser === null) {
                this.$eventBus.$emit('doLogin');
                return;
            }
            // || this.info.status === '待完善资料' || this.info.status.includes('未通过') && path !== '/Index/profile'

            if (this.info.status === '已禁用') {
                this.$hint.message.info(this.$t('账号已被禁用'));
                return;
            }

            if (path === '/Index/profile') {
                this.$router.push(path);
                return;
            }

            if (this.info.status === '待完善资料') {
                this.$hint.message.info(this.$t('请先完善个人资料'));
                return;
            }

            if (this.info.status === '待审核') {
                this.$hint.message.info(this.$t('请等待管理员审核通过'));
                return;
            }

            if (this.info.status === '审核未通过') {
                this.$hint.message.info(this.$t('审核未通过，请重新完善资料'));
                return;
            }

            this.$router.push(path);

        },
        changeLanguage(lang) {
            this.$i18n.locale = lang; // 切换语言
            this.$cookie.set('ldz_language',lang,30);
            location.reload();
        },
        calSelectIcon() {
            let indexRoute = [
              '我的 - 链大宗商品平台','关于我们 - 链大宗商品平台','个人资料 - 链大宗商品平台','我的订单 - 链大宗商品平台','我的关注 - 链大宗商品平台','我的在售 - 链大宗商品平台',
              '求购记录 - 链大宗商品平台'
            ];
            if (indexRoute.includes(this.$route.name)) {
                this.selectedIcon = '我的';
            }

            let shopRoute = ['商城 - 链大宗商品平台','商品详情 - 链大宗商品平台']
            if (shopRoute.includes(this.$route.name)) {
                this.selectedIcon = '商城';
            }

            let bidRoute = ['竞价 - 链大宗商品平台'];
            if (bidRoute.includes(this.$route.name)) {
                this.selectedIcon = '竞拍';
            }

            let monitorRoute = ['监管仓 - 链大宗商品平台'];
            if (monitorRoute.includes(this.$route.name)) {
                this.selectedIcon = '监管仓';
            }

            let transportRoute = ['物流 - 链大宗商品平台'];
            if (transportRoute.includes(this.$route.name)) {
                this.selectedIcon = '物流';
            }

            let DataRoute = ['AI数据 - 链大宗商品平台'];
            if (DataRoute.includes(this.$route.name)) {
                this.selectedIcon = 'AI数据';
            }

            let notFoundRoute = ['走丢了 - 链大宗商品平台'];
            if (notFoundRoute.includes(this.$route.name)) {
                this.selectedIcon = '';
            }
        }
    },
    created() {
        this.getAllLoginToken();
        // 弹出登录
        this.$eventBus.$on('doLogin',() => {
            this.isMobileLoginDialogShow = true;
        });
        this.$eventBus.$on('sendPhoneVerificationCode',() => {
            this.sendPhoneVerificationCode();
        });

        // this.innerWidth = window.innerWidth;

        let that = this;
        this.$store.commit('setDeviceType', window.innerWidth > 1140 ? 'pc' : 'mobile');
        window.addEventListener('resize', function() {
            that.$store.commit('setDeviceType', window.innerWidth > 1140 ? 'pc' : 'mobile');
        });
    },

    mounted() {
        let account = this.$cookie.get('account');
        let password = this.$cookie.get('password');
        if (!this.$verify.checkIfNull(account) && !this.$verify.checkIfNull(password) && this.$store.state.currentUser === null) {
            console.log('自动登录');
            this.$http.doLogin(account, password).then(res => {
                this.isLoginBtnLoading = false;
                if (res.code === 200) {
                    this.$store.commit('setToken', res.data.e1);
                    this.$store.commit('setCurrentUser', res.data.e2);
                    location.reload();
                }else {
                    this.$hint.message.info(this.$t('错误的账号或密码'));
                    this.$cookie.delete('account');
                    this.$cookie.delete('password');
                }
            })
        }

        this.getUserInfo();
        this.calSelectIcon();
    },
}
